export default {
  tab: {
    allExchanges: 'Toàn Thị Trường',
    hose: 'HOSE',
    hnx: 'HNX',
    upcom: 'UPCOM',
    vn30: 'VN30',
    hnx30: 'HNX30',
  },

  tabDataChange: {
    tabDataChangeTab: {
      overview: 'TỔNG QUAN',
      performance: 'BIẾN ĐỘNG GIÁ',
      financial: 'TÀI CHÍNH',
      technical: 'KỸ THUẬT',
      chart: 'BIỂU ĐỒ',
    },
  },

  performance: {
    listTitleTable: {
      TICKER: 'MÃ',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE_1DAY: '1 Ngày',
      PERCENT_PRICE_CHANGE_1WEEK: '1 Tuần',
      PERCENT_PRICE_CHANGE_2WEEK: '2 Tuần',
      PERCENT_PRICE_CHANGE_1MONTH: '1 Tháng',
      PERCENT_PRICE_CHANGE_3MONTH: '3 Tháng',
      PERCENT_PRICE_CHANGE_6MONTH: '6 Tháng',
      PERCENT_PRICE_CHANGE_9MONTH: '9 Tháng',
      PERCENT_PRICE_CHANGE_1YEAR: '1 Năm',
      PERCENT_PRICE_CHANGE_YTD: 'Tính đến hiện tại',
    },
  },
  overview: {
    overviewHeader: {
      TICKER: 'MÃ',
      SECTOR_NAME: 'NGÀNH',
      VOLUME: 'KLGD',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      RTD11: 'VỐN HÓA',
      RTD21: 'P/E',
      PB: 'P/B',
      RANKING: 'XẾP HẠNG',
    },
    overviewTopValueHeader: {
      TICKER: 'MÃ',
      SECTOR_NAME: 'NGÀNH',
      VALUE: 'GTGD',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      RTD11: 'VỐN HÓA',
      VOLUME: 'KHỐI LƯỢNG',
      RANKING: 'XẾP HẠNG',
      PB: 'P/B',
      PE: 'P/E',
    },

    overviewTopNewHighHeader: {
      TICKER: 'MÃ',
      SECTOR_NAME: 'NGÀNH',
      VALUE: 'GTGD',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      RTD11: 'VỐN HÓA',
      VOLUME: 'KHỐI LƯỢNG',
      OLD_HIGH: 'ĐỈNH CŨ',
      RANKING: 'XẾP HẠNG',
      PB: 'P/B',
      PE: 'P/E',
    },

    overviewTopNewLowHeader: {
      TICKER: 'MÃ',
      SECTOR_NAME: 'NGÀNH',
      VALUE: 'GTGD',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      RTD11: 'VỐN HÓA',
      VOLUME: 'KHỐI LƯỢNG',
      OLD_LOW: 'ĐÁY CŨ',
      RANKING: 'XẾP HẠNG',
      PB: 'P/B',
      PE: 'P/E',
    },
    overviewTopForeignTradeHeader: {
      TICKER: 'MÃ',
      SECTOR_NAME: 'NGÀNH',
      VALUE: 'GTGD',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      RTD11: 'VỐN HÓA',
      VOLUME: 'KLGD',
      FOREIGN_BUY_VOL: 'KLNN MUA RÒNG',
      FOREIGN_BUY_VALUE: 'GTNN MUA RÒNG',
      FOREIGN_SELL_VOL: 'KLNN BÁN RÒNG',
      FOREIGN_SELL_VALUE: 'GTNN BÁN RÒNG',
      OLD_LOW: 'ĐÁY CŨ',
      RANKING: 'XẾP HẠNG',
      RTD21: 'P/E',
      PB: 'P/B',
      PE: 'P/E',
    },
  },
  financial: {
    financialHeader: {
      TICKER: 'MÃ',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      ISA3: 'DOANH THU<br>(TTM)',
      ISA20: 'LỢI NHUẬN RÒNG<br>(TTM)',
      RTD14: 'EPS<br>(TTM)',
      RTD7: 'BVPS (VND)<br> (TTM)',
      RTD21: 'P/E',
      RTD25: 'P/B',
      NET_PROFIT_GROWTH: 'Tăng trưởng <br> lãi thuần (TTM)',
      EBIT_MARGIN: 'Tỷ suất<br> EBIT (TTM)',
      SECTOR_NAME: 'Ngành',
    },
  },
  technical: {
    technicalHeader: {
      TICKER: 'MÃ',
      VOLUME: 'KLGD',
      PRICE: 'GIÁ',
      PERCENT_PRICE_CHANGE: '% THAY ĐỔI',
      SMA20: 'SMA20',
      SMA50: 'SMA50',
      SMA100: 'SMA100',
      RSI: 'RSI',
      CANDLE_STICK: 'MÔ HÌNH NẾN',
    },
  },
};
